import React, { useState } from "react";
import { Form, Input, Button, Checkbox, notification } from "antd";
import {
  emailValidation,
  passValidation,
  minLengthValidation,
} from "../../../utils/formValidation";
import { post } from "../../../api/post";

import "./RegisterForm.scss";

export default function RegisterForm() {
  const [inputs, setInputs] = useState({ 
    email: "",
    password: "",
    repeatPassword: "",
    privacyPolicy: false,
  });
  const [valido, setValido] = useState({
    email: false,
    password: false,
    repeatPassword: false,
    privacyPolicy: false,
  });

  const changeForm = (e) => {
  //  console.log("Ey");
    if (e.target.name === "privacyPolicy") {
      setInputs({
        ...inputs,
        [e.target.name]: e.target.checked,
      });
    } else {
      setInputs({
        ...inputs,
        [e.target.name]: e.target.value,
      });
    }
  };

  const inputValidation = (e) => {
    const { type, name } = e.target;
    // console.log(type)
    // console.log(name)
    // console.log(e.target)
    // console.log(valido)
    // console.log(emailValidation(e.target))
    // console.log(minLengthValidation(e.target, 6))
    if (type === "email") {
      setValido({ ...valido, [name]: emailValidation(e.target) });
    }
    if (type === "password") {
      setValido({ ...valido, [name]: minLengthValidation(e.target, 6) });
    }
    if (type === "checkbox") {
      setValido({ ...valido, [name]: e.target.checked });
    }
    
  };



  const register = async (e) => {
    // console.log('q')
    // console.log(passValidation("Password1"));  // Debería devolver true
    // console.log(passValidation("password"));   // Debería devolver false
    // console.log(passValidation("PASSWORD"));   // Debería devolver false
    // console.log(passValidation("Password"));   // Debería devolver false
    // console.log(passValidation("123456789")); 
    const emailVal = inputs.email;
    const passwordVal = inputs.password;
    const repeatPasswordVal = inputs.repeatPassword;
    const privacyPolicyVal = inputs.privacyPolicy;

    if (!emailVal || !passwordVal || !repeatPasswordVal || !privacyPolicyVal) {
      notification["error"]({
        message: "Todos los campos son obligatorios",
      });
    } else if (!emailValidation(emailVal)) {
      notification["error"]({
        message: "Email incorrecto, añade un email con el formato correcto.",
      });
    } else if (!passValidation(repeatPasswordVal)||!minLengthValidation(repeatPasswordVal,8)||repeatPasswordVal!==passwordVal) {
      notification["error"]({
        message: "Contraseñas incorrectas, tienen que tener al menos 8 carácteres, una mayuscula, una minúscula y un número.",
      });
    } else {
      if (passwordVal !== repeatPasswordVal) {
        notification["error"]({
          message: "Las contraseñas tienen que ser iguales.",
        });
      } else {
        const result = await post(inputs,'sign-up','sign-up','');
        // const result = await signUpApi(inputs);
        // console.log(result.user)
        // console.log(!result.user)
        if (!result.user) {
          notification["error"]({
            //Esto son los alerts
            message: 'Error al registrar el usuario',
          });
        } else {
          notification["success"]({
            message: 'Usuario registrado.',
          });
          resetForm(); //Reseteo el usuario
        }
      }
    }
  };

  const resetForm = () => {
    // console.log('e')
    const inputs = document.getElementsByTagName("input");

    for (let i = 0; i < inputs.length; i++) {
      inputs[i].classList.remove("success");
      inputs[i].classList.remove("error");
    }

    setInputs({
      email: "",
      password: "",
      repeatPassword: "",
      privacyPolicy: false,
    });

    setValido({
      email: false,
      password: false,
      repeatPassword: false,
      privacyPolicy: false,
    });
  };

  return (
    <Form className="register-form" onFinish={register} onChange={changeForm}>
      <Form.Item>
        <Input
          type="email"
          name="email"
          placeholder="Correo electronico"
          className="register-form__input"
          // onChange={(e)=>inputValidation_(e)}
          value={inputs.email}
        />
      </Form.Item>
      <Form.Item>
        <Input
          type="password"
          name="password"
          placeholder="Contraseña"
          className="register-form__input"
          // onChange={inputValidation}
          value={inputs.password}
        />
      </Form.Item>
      <Form.Item>
        <Input
          type="password"
          name="repeatPassword"
          placeholder="Repetir contraseña"
          className="register-form__input"
          // onChange={inputValidation}
          value={inputs.repeatPassword}
        />
      </Form.Item>
      <Form.Item className="register-form__check" >
        
        <Checkbox
          name="privacyPolicy"
          // onChange={inputValidation}
          checked={inputs.privacyPolicy}
        >
          He leído y acepto la política de privacidad.
        </Checkbox>
      </Form.Item>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="register-form__button"
        >
          Crear cuenta
        </Button>
      </Form.Item>
    </Form>
  );
}
